import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { css } from 'styled-components';
import { color } from '../../../../system/mixins';
import { colorBlue10, colorBlue30 } from '../../../../tokens';
export var getLinkOverride = function getLinkOverride(_ref) {
  var pressed = _ref.pressed,
      disabled = _ref.disabled;
  var result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        color: ", ";\n        &:focus {\n            color: ", ";\n        }\n        &:hover:active {\n            color: ", ";\n        }\n        &:visited {\n            color: ", ";\n        }\n    "])), color('primary.lighter'), color('primary.lighter'), colorBlue10, color('purple.02'));

  if (pressed) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, colorBlue30);
  }

  if (disabled) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('neutral.05'));
  }

  return result;
};